/* Tooltips */

$( function() {
	$('.tooltip').tooltip();
} );
